/* eslint-disable max-len */
import { FunctionComponent, useState } from 'react';
import { CircularProgress, FormControl } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/client';

import TextInput from '../../components/input';
import useForm from '../../customHooks/useForm';
import AdminAuthWrapper from '../../components/AdminAuthWrapper';
import { RESET_PASSWORD } from '../../graphql/admin_mutations';
import useToast from '../../customHooks/useToast';

import EmailIcon from '../../svgs/EmailIcon';

import styles from './PasswordReset.module.scss';

const PasswordReset: FunctionComponent = () => {
  const [mailSent, setMailSent] = useState(false);
  const [adminForgotPasswordApi] = useMutation<
    { adminForgotPassword: any; resetPasswordInfo: any },
    any
  >(RESET_PASSWORD);
  const [loading, setLoading] = useState(false);
  const Toast = useToast();

  const {
    formValues,
    handleChange,
  } = useForm(
    {
      email: '',
    },
  );

  const handleOnSubmit: (arg: any) => void = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload: any = {
        email: formValues?.email,
      };

      const resp = await adminForgotPasswordApi({ variables: payload });
      if (
        resp?.data?.adminForgotPassword
        && resp?.data?.adminForgotPassword?.status === 200
      ) {
        Toast.success('Password reset is successful');
        setLoading(false);
        setMailSent(true);
      } else {
        Toast.error(
          resp?.data?.adminForgotPassword?.message
          || 'Something went wrong. Try again.',
        );
        setMailSent(false);
      }
    } catch (e) {
      setLoading(false);
      if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
        Toast.error(e.graphQLErrors[0].message);
      } else {
        console.log('e', e);
        Toast.error('Something went wrong. Try again or Contact Support');
      }
    }
  };

  return (
    <AdminAuthWrapper handleOnSubmit={handleOnSubmit} headText={`${mailSent ? 'Set New Password' : 'Forgot Password'}`}>
      <div className={styles?.passwordReset}>
        {mailSent ? (
          <h6 className={styles?.passwordReset__mailSentText}>
            A password reset request has been sent to
            {' '}
            <span className={styles?.passwordReset__mailStyled}>{formValues?.email}</span>
            . Please follow the instructions provided in the email for the next steps in the process.
          </h6>
        ) : (
          <form className={styles?.passwordReset__form} action="" onSubmit={handleOnSubmit}>
            <FormControl className={styles?.passwordReset__content}>
              <TextInput
                customOnChange={handleChange}
                name="email"
                value={formValues.email}
                label="Email Address"
                width="100%"
                preIcon={<EmailIcon />}
                paddingLeft="44px"
              />
              <button className={`mb-2 ${!formValues.email ? styles?.passwordReset__disabled : 'bg-primary'} text-white rounded ${styles?.passwordReset__btn}`} disabled={!formValues.email}>
                {loading ? (
                  <CircularProgress color="inherit" size={15} />
                ) : (
                  'Reset password'
                )}

              </button>
            </FormControl>
          </form>
        )}
        <div className={styles?.passwordReset__create}>
          Already have an account?
          {' '}
          <Link className={styles?.passwordReset__link} to="/"><span className={styles?.passwordReset__createText}>Log in</span></Link>
        </div>
      </div>
    </AdminAuthWrapper>
  );
};

export default PasswordReset;
